import PropTypes from "prop-types";
import { JDN_ENUMS, STATE_ENUMS } from "../../petitionList/jurisdictionEnums";
import OverallOpinionFl from "./OverallOpinionFl/OverallOpinionFl";

const OverallOpinion = ({ petitionInfo }) => {
  const jdn = petitionInfo?.jurisdiction?.jdn;
  const state = petitionInfo?.jurisdiction?.state;
  const fireDbPath = petitionInfo?.fireDbPath;

  let guts = <></>;
  if (jdn === JDN_ENUMS.STATE && state === STATE_ENUMS.fl) {
    guts = <OverallOpinionFl fireDbPetitionPath={fireDbPath} />;
  }

  return guts;
};

OverallOpinion.propTypes = {
  petitionInfo: PropTypes.object,
};

export default OverallOpinion;
